import { useMutation } from '@tanstack/react-query'

import { makeSamlOptional } from '@src/api'
import { DefaultApiMakeSamlOptionalRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useMakeSamlOptional = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiMakeSamlOptionalRequest) =>
      makeSamlOptional(axiosInstance, params),
  })
}
